// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"648":"48e256ba","842":"0ff7d119"}[chunkId] + ".chunk.js";
};